import { Typography } from "@/components/typography";
import Link from "next/link";
import { ProductDetailsResponse } from "@/types/product";
import { priceSymbol } from "@/utils/price-count";
import ProductCardImage from "./product-card-image";
import { Tooltip } from "../tooltip/Tooltip";

const DIV_CLASSNAMES = {
  featureProducts:
    "md:w-full  w-full  lg:max-w-[23%]  md:p-5 lg:p-0 mb-3  mx-auto relative cursor-pointer",
  relatedProduct: "md:w-[32%] lg:w-[24%] xl:w-[19%] aspect-auto",
  products: "w-full aspect-auto",
};

interface Props {
  product: ProductDetailsResponse;
  pageType: "featureProducts" | "relatedProduct" | "products";
  hideDescription?: boolean;
}

export const ProductCardUI = ({
  product,
  pageType,
  hideDescription,
}: Props) => {
  const { name, price, flatDiscount, description, slug, id } = product;
  const formattedName =
    name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

  return (
    <div className={`${DIV_CLASSNAMES[pageType]}`}>
      <div key={id} className="w-full aspect-auto">
        <div className="relative w-full group/products aspect-square p-3 overflow-hidden border rounded-md bg-white shadow-sm">
          <Link href={`/products/${slug}`}>
            <ProductCardImage product={product} />
          </Link>

          {flatDiscount > 0 && (
            <div className="absolute bg-yellow text-black text-sm font-semibold px-2 py-1 top-3 left-3 rounded-sm">
              Flat {priceSymbol(flatDiscount)} off
            </div>
          )}
        </div>
        <div className="py-2">
          <Link href={`/products/${slug}`}>
            <Tooltip text={formattedName}>
              <Typography
                tag="h3"
                className="my-1 line-clamp-3 w-[90%] max-h-fit text-[1.1em]"
              >
                {formattedName}
              </Typography>
            </Tooltip>
            {!hideDescription && (
              <Typography
                tag="p"
                className="text-gray-600 m-0 mt-2 max-h-fit line-clamp-2"
              >
                {description}
              </Typography>
            )}
          </Link>
          <div className="flex gap-2 items-center h-fit">
            {flatDiscount > 0 && (
              <Typography
                tag="h6"
                className={`text-gray-400 line-through text-lg ${pageType === "products" ? "my-1" : ""}`}
              >
                {priceSymbol(price)}
              </Typography>
            )}
            <Typography
              tag="h6"
              className={`text-primary text-lg ${pageType === "products" ? "my-1" : ""}`}
            >
              {priceSymbol(price - flatDiscount)}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};
